import React, { useState } from "react";
import styles from "./SelectAddressBottomSheet.module.scss";
import { Image } from "@src/components/Image";
import Modal from "@src/components/UIElements/Modal";
import Button from "@src/components/UIElements/Button";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import AddressTemplate from "./AddressTemplate";
import { useEffect } from "react";
import {
  addressEditModeToggleAction,
  sendAddressDataAction,
  setActiveAddressAction,
} from "../../../PhysicalAddress/store/actions";
import DeleteAddress from "./DeleteAddress";
import { useRouter } from "@src/lib/router";
import { initialisePaymentService } from "@src/PaymentService";
import CONSTANTS from "../../../PhysicalAddress/store/constants";
import { captureInterest } from "@src/components/Tabs/Overview/store/actions";
import { newWebEngage } from "@src/utils/webEngageEvent";

const SelectAddressBottomSheet = () => {
  // ROUTER
  const router = useRouter();
  // LOCAL STATES
  const [isDefault, setIsDefault] = useState(0);
  // TRANSLATOR
  const { t } = useTranslation();
  // DISPATCH
  const dispatch = useDispatch();

  const selectDefault = (data) => {
    dispatch(setActiveAddressAction(data));
  };

  const sendAddressData = (actionType, payload) => {
    dispatch(sendAddressDataAction(actionType, payload));
  };

  const addNewAddress = () => {
    dispatch(addressEditModeToggleAction(false));

    router.push(`/${router?.query.courseId}/physicaladdress`);
    dispatch(actionCreator.showSelectAddressBottomSheetAction(false));
  };

  const pincodeErrorMsg = useSelector(
    (state) => state?.physicalShipmentReducer?.picodeErrorMessage
  );

  const bundles = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.bundles
  );

  const isBooksAdded = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.isBooksAdded
  );

  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );

  const purchaseViaWhatsapp = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsapp
  );

  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );

  const overViewData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );

  const updateAddress = () => {
    sendAddressData(CONSTANTS.SHIPMENT_EDITADDRESSDATA_PUT, {
      ...activeAddress,
      isDefault,
      addressId: activeAddress?.id,
      skipUpdates: true,
      onSuccess: initialisePaymentService,
    });
  };
  // SELECTORS
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showSelectAddressBottomSheet
  );

  const addressList = useSelector(
    (state) => state?.physicalShipmentReducer?.addressList
  );

  const activeAddress = useSelector(
    (state) => state?.physicalShipmentReducer?.activeAddress
  );

  const showPopup = useSelector(
    (state) => state?.bottomSheetReducer?.showDeleteAddressPopup
  );

  const overviewReducer = useSelector((state) => state?.overviewReducer);
  const { comboCourseList, comboCourseId } = overviewReducer;
  const isComboActive = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isComboActive
  );

  useEffect(() => {
    let defaultAddress;
    if (addressList?.length && !activeAddress?.id) {
      defaultAddress = addressList?.filter((item) => item?.isDefault);
      selectDefault(...defaultAddress);
    }
  }, [addressList]);

  useEffect(() => {
    if (activeAddress) {
      setIsDefault(activeAddress?.isDefault);
    }
  }, [activeAddress?.id]);

  return (
    <Modal
      handleClose={() => {
        dispatch(actionCreator.showSelectAddressBottomSheetAction(false));
      }}
      header={
        <div className="UpcomingLive__ModalHeader">
          <Image
            src={getAwsAssets("locationIcon.svg", "bottomSheets")}
            alt={t(
              "components.bottomSheets.components.selectAddressBottomSheet.locationIcon",
              "locationIcon"
            )}
            width="28px"
            height="28px"
          />
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.selectAddress",
            "Select Address"
          )}
        </div>
      }
      footer={
        <div className={styles.SelectAddressBottomSheet__Footer}>
          <div
            className={styles.SelectAddressBottomSheet__Footer__Default}
            onClick={() => setIsDefault(isDefault ? 0 : 1)}
          >
            <input type="checkbox" checked={isDefault} label="Set as Default" />{" "}
            Set as Default
          </div>

          <Button
            onClick={() => {
              if (purchaseViaWhatsapp) {
                const payload = {
                  courseId: courseId,
                  courseName: overViewData?.details?.name,
                };
                newWebEngage("course_interested_whatsapp_click", {
                  sub_source_id: courseId,
                });
                dispatch(captureInterest(payload));
              } else {
                if (isDefault && isDefault != activeAddress?.isDefault) {
                  updateAddress();
                } else {
                  if (isComboActive) {
                    initialisePaymentService(comboCourseList, comboCourseId);
                  } else {
                    initialisePaymentService();
                  }
                }
              }
            }}
            disabled={
              !addressList?.length ||
              pincodeErrorMsg ||
              (bundles?.length > 0 &&
                !activeAddress?.email &&
                activeAddress?.id &&
                isBooksAdded)
            }
          >
            {purchaseViaWhatsapp || purchaseViaWhatsappV2 === 1
              ? t(
                "components.bottomSheets.components.selectStateBottomSheet.proceed",
                "Proceed"
              ) : t(
                "components.bottomSheets.components.selectStateBottomSheet.proceedToPayment",
                "Proceed to Payment"
              )}
          </Button>
        </div>
      }
    >
      <div className={styles.SelectAddressBottomSheet}>
        <p className={styles.SelectAddressBottomSheet__subtext}>
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.studyMaterialShipped",
            "Your Study materials will be shipped to this address"
          )}
        </p>
        <h1 className={styles.SelectAddressBottomSheet__heading}>
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.savedAddress",
            "Saved Addresses"
          )}
        </h1>

        <div className={styles.SelectAddressBottomSheet__AddressList}>
          {addressList?.map((item, i) => (
            <AddressTemplate {...item} key={i} />
          ))}
          <Button outline onClick={addNewAddress}>
            {` + `}
            {t(
              "components.bottomSheets.components.selectAddressBottomSheet.addAddressText",
              "Add a new Address"
            )}
          </Button>
        </div>
      </div>

      {showPopup ? <DeleteAddress /> : null}
    </Modal>
  );
};

export default SelectAddressBottomSheet;
